import React from "react";
import { NavLink } from 'react-router-dom';
import BannerImage from '../assets/images/home=meet-banner.jpg';
import MobileBannerImage from '../assets/images/home=meet-banner-mobile.jpg';
import upWhiteArrow from '../assets/images/upWhiteArrow.svg';

function meetUs(){
    return(
        <>
        <div className="meet_us position-relative" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">    
            <picture>
                <source media="(max-width: 767px)" srcSet={MobileBannerImage} />
                <img className="position-absolute h-100 w-100 s-0 t-0 meetbgimg" src={BannerImage} alt="Banner Image" />
            </picture>                     
            <div className="meetus_banner_content position-relative plr-100 text-center fw-200">  
                <div className="container text-white">
                    <div className="meetus_banner_content_inr">
                        <h2 className="m-0" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">meet us</h2>
                        <p data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">We make great coffee and exceptional food within beautifully designed spaces tailored to each location and community. Our approach is simple. Do it with love.</p>
                        <NavLink className="morebtn" exact to="/about" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">MORE<img src={upWhiteArrow} alt="arrow-icon" /></NavLink>
                    </div>
                </div>
            </div>             
        </div>        
        </>
    );
}
export default meetUs;